// Development environment configuration for CheckerFly
// WI-017b: Multi-environment support - Dev environment
// This configuration is used for local development and dev deployments

import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCAngV1OzUh6gz0Mu1UpQGPbocBDx3MiPI',
    authDomain: 'checkerfly-5ec18.firebaseapp.com',
    projectId: 'checkerfly-5ec18',
    storageBucket: 'checkerfly-5ec18.firebasestorage.app',
    messagingSenderId: '985534900227',
    appId: '1:985534900227:web:433d29a40cdf3b052c8636',
    measurementId: 'G-K8J5BR96RY',
  },
  // Emulator configuration for local development
  // Using computer's IP (10.0.0.73) so both browser AND phone can access emulators
  // firebase.json configured with host: "0.0.0.0" to accept external connections
  useEmulators: true,
  emulators: {
    auth: 'http://10.0.0.73:9099',
    firestore: 'http://10.0.0.73:8080',
    functions: 'http://10.0.0.73:5001',
  },
  apiUrl: 'https://dev-api.checkerfly.app', // Placeholder for future API endpoint

  /**
   * ⚠️ DEVELOPMENT ONLY - Test user credentials
   *
   * **SECURITY WARNING**: This configuration MUST be removed before production launch
   *
   * **Purpose**: Documents test phone number for development/testing
   * - Phone: Enter "5555550100" in the UI (the +1 prefix is added automatically)
   * - OTP: Emulator generates random 6-digit codes. Retrieve via:
   *   1. Terminal logs: Look for "To verify the phone number +15555550100, use the code XXXXXX"
   *   2. Emulator UI: http://localhost:4000/logs
   *   3. REST API (for automated testing): GET http://localhost:9099/emulator/v1/projects/checkerfly-5ec18/verificationCodes
   *
   * **Note**: 555 numbers are reserved for testing and won't work in production Firebase Auth
   * (only works with emulator), so this poses no production security risk even if knowledge leaks
   *
   * **TODO (Phase 4 Production Gate)**: Remove this configuration before MVP launch
   * **Safeguards**:
   * - Only defined in environment.dev.ts (not in environment.prod.ts)
   * - Dev ribbon shown only when !production AND testUser existence
   * - Build verification should fail if production has testUser defined
   * - 555 numbers are emulator-only (won't authenticate in production Firebase)
   *
   * @see WI-051 - Firestore Security Rules (production gate checklist)
   */
  testUser: {
    phoneNumber: '+15555550100',
  },
};
